import { Logger } from "./logger";
import { CookieManager } from "./cookie";
import { COOKIE_SESSION, SESSION_DURATION_DAYS } from "./config";

let memorySessionId: string | null = null;

function generateUUID(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function isValidUUID(value: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
}

export const SessionManager = {
  getOrCreate(): string {
    const existing = CookieManager.get(COOKIE_SESSION);

    if (existing && isValidUUID(existing)) {
      this.persist(existing);
      Logger.log(`Session resumed: ${existing}`);
      return existing;
    }

    if (memorySessionId && isValidUUID(memorySessionId)) {
      this.persist(memorySessionId);
      Logger.log(`Session restored from memory: ${memorySessionId}`);
      return memorySessionId;
    }

    const newId = generateUUID();
    memorySessionId = newId;
    this.persist(newId);
    Logger.log(`New session created: ${newId}`);
    return newId;
  },

  getCurrent(): string | null {
    const fromCookie = CookieManager.get(COOKIE_SESSION);
    if (fromCookie && isValidUUID(fromCookie)) return fromCookie;
    if (memorySessionId && isValidUUID(memorySessionId)) return memorySessionId;
    return null;
  },

  destroy(): void {
    CookieManager.delete(COOKIE_SESSION);
    memorySessionId = null;
    Logger.log("Session destroyed");
  },

  persist(sessionId: string): void {
    CookieManager.set(COOKIE_SESSION, sessionId, SESSION_DURATION_DAYS);
    memorySessionId = sessionId;
  },
};
